import type { IAccountProfileImage } from '@models/IAccountProfileImage';
import classNames from 'classnames';

interface Props {
  readonly image?: IAccountProfileImage;
  readonly initials?: string;
  readonly sizeClassName?: string;
  readonly initialsSize?: string;
  readonly backgroundColor?: string;
  readonly initialsColor?: string;
  readonly dataTestId?: string;
}

const AccountProfileImage = ({
  image,
  initials,
  sizeClassName = 'w-[70px] h-[70px]',
  initialsSize = 'h6',
  backgroundColor = 'bg-grey-100',
  initialsColor = 'text-grey-450',
  dataTestId = 'Account-Profile-Image',
}: Props) =>
  image?.imageData ? (
    <img
      alt="account-profile"
      className={classNames('rounded-full object-cover', sizeClassName)}
      src={`data:${image.contentType ?? 'image/jpeg'};base64,${
        image.imageData
      }`}
      data-testid={dataTestId}
    />
  ) : (
    <div
      className={classNames(
        'flex items-center justify-center rounded-full',
        backgroundColor,
        sizeClassName
      )}
      data-testid={dataTestId}
    >
      {initials && (
        <span className={classNames('uppercase', initialsSize, initialsColor)}>
          {initials}
        </span>
      )}
    </div>
  );

export default AccountProfileImage;
